import {
  Box,
  Grid,
  makeStyles,
  Tabs,
  Tab,
  Paper,
  //   Typography,
} from "@material-ui/core";
import TabPanel from "src/utils/TabPanel";
import React, { useEffect, useState } from "react";
import NSPaidLaboratoryOrder from "./NSPaidLaboratoryOrder";
import LaboratorySharedImages from "src/doctor/patients/laboratory/LaboratorySharedImages";
import NSLaboratoryDocAttachments from "./NSLaboratoryDocAttachments";

const useStyle = makeStyles({
  indicatorLeft: {
    left: "0px",
  },
});

const NSLaboratoryTabs = ({ patient_id }) => {
  const classes = useStyle();
  const [category, setCategory] = useState("order-paid");

  const handleChange = (event, cat) => {
    event.persist();
    setCategory(cat);
  };

  useEffect(() => {}, [patient_id]);

  return (
    <Grid container spacing={2}>
      <Box clone order={{ xs: 2, sm: 2, md: 1 }}>
        <Grid item xs={12} sm={12} md={9}>
          <TabPanel value={category} index={"order-paid"}>
            <NSPaidLaboratoryOrder
              connection={"local"}
              patient_id={patient_id}
            />
          </TabPanel>

          <TabPanel value={category} index={"shared-image"}>
            <LaboratorySharedImages
              patient_id={patient_id}
              connection={"local"}
            />
          </TabPanel>

          <TabPanel value={category} index={"doc-attachment"}>
            <NSLaboratoryDocAttachments patient_id={patient_id} />
          </TabPanel>
        </Grid>
      </Box>

      <Box clone order={{ xs: 1, sm: 1, md: 2 }}>
        <Grid item xs={12} sm={12} md={3}>
          <Box component={Paper} elevation={2} mb={2}>
            <Tabs
              value={category}
              onChange={handleChange}
              scrollButtons="on"
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              orientation={window.innerWidth > 959 ? "vertical" : "horizontal"}
              classes={{
                indicator: classes.indicatorLeft,
              }}
            >
              <Tab wrapped value="order-paid" label={"Paid Order"} />
              <Tab wrapped value="shared-image" label="Shared Image" />
              <Tab wrapped value="doc-attachment" label=" Attachments" />
            </Tabs>
          </Box>
        </Grid>
      </Box>
    </Grid>
  );
};

export default NSLaboratoryTabs;
